/** PARSEC v1.2S isochrones (B−V vs Mv) from Padova CMD 3.9 — Z=0.0152, Av=0. */

import type { AgeIsochrone, IsoPoint } from './isochrones';

export const PARSEC_SOURCE = 'Padova CMD 3.9 · PARSEC v1.2S · Z=0.0152';

const RAW: Record<string, IsoPoint[]> = {
  '0.080': [
    { mv: 13.988, bv: 1.842 },
    { mv: 13.535, bv: 1.827 },
    { mv: 12.811, bv: 1.764 },
    { mv: 11.658, bv: 1.655 },
    { mv: 10.822, bv: 1.582 },
    { mv: 10.228, bv: 1.53 },
    { mv: 9.749, bv: 1.493 },
    { mv: 9.356, bv: 1.461 },
    { mv: 8.997, bv: 1.401 },
    { mv: 8.445, bv: 1.276 },
    { mv: 7.86, bv: 1.205 },
    { mv: 7.316, bv: 1.091 },
    { mv: 7.203, bv: 1.065 },
    { mv: 6.852, bv: 0.995 },
    { mv: 6.33, bv: 0.905 },
    { mv: 5.886, bv: 0.826 },
    { mv: 5.452, bv: 0.736 },
    { mv: 5.035, bv: 0.655 },
    { mv: 4.628, bv: 0.579 },
    { mv: 4.368, bv: 0.532 },
    { mv: 3.91, bv: 0.458 },
    { mv: 3.5, bv: 0.394 },
    { mv: 3.136, bv: 0.331 },
    { mv: 2.807, bv: 0.263 },
    { mv: 2.653, bv: 0.231 },
    { mv: 2.381, bv: 0.167 },
    { mv: 2.149, bv: 0.109 },
    { mv: 1.956, bv: 0.066 },
    { mv: 1.788, bv: 0.032 },
    { mv: 1.637, bv: 0.006 },
    { mv: 1.497, bv: -0.015 },
    { mv: 1.365, bv: -0.032 },
  ],
  '0.100': [
    { mv: 13.668, bv: 1.826 },
    { mv: 12.612, bv: 1.727 },
    { mv: 11.839, bv: 1.655 },
    { mv: 11.321, bv: 1.611 },
    { mv: 10.878, bv: 1.572 },
    { mv: 9.865, bv: 1.489 },
    { mv: 9.195, bv: 1.427 },
    { mv: 8.39, bv: 1.256 },
    { mv: 7.895, bv: 1.19 },
    { mv: 7.808, bv: 1.174 },
    { mv: 6.953, bv: 1.015 },
    { mv: 6.49, bv: 0.936 },
    { mv: 6.131, bv: 0.871 },
    { mv: 5.761, bv: 0.799 },
    { mv: 5.149, bv: 0.677 },
    { mv: 4.878, bv: 0.624 },
    { mv: 4.549, bv: 0.564 },
    { mv: 4.13, bv: 0.494 },
    { mv: 3.696, bv: 0.425 },
    { mv: 3.31, bv: 0.363 },
    { mv: 3.133, bv: 0.331 },
    { mv: 2.802, bv: 0.264 },
    { mv: 2.52, bv: 0.201 },
    { mv: 2.374, bv: 0.167 },
    { mv: 2.159, bv: 0.114 },
    { mv: 2.041, bv: 0.086 },
    { mv: 1.859, bv: 0.048 },
    { mv: 1.698, bv: 0.02 },
    { mv: 1.622, bv: 0.008 },
    { mv: 1.545, bv: -0.003 },
    { mv: 1.411, bv: -0.023 },
    { mv: 1.329, bv: -0.031 },
  ],
  '0.200': [
    { mv: 13.432, bv: 1.759 },
    { mv: 13.271, bv: 1.742 },
    { mv: 12.819, bv: 1.702 },
    { mv: 12.022, bv: 1.635 },
    { mv: 11.497, bv: 1.593 },
    { mv: 10.409, bv: 1.509 },
    { mv: 9.833, bv: 1.467 },
    { mv: 9.321, bv: 1.416 },
    { mv: 9.119, bv: 1.361 },
    { mv: 8.733, bv: 1.294 },
    { mv: 8.069, bv: 1.218 },
    { mv: 7.476, bv: 1.119 },
    { mv: 7.011, bv: 1.031 },
    { mv: 6.49, bv: 0.938 },
    { mv: 6.101, bv: 0.866 },
    { mv: 5.438, bv: 0.735 },
    { mv: 5.138, bv: 0.675 },
    { mv: 4.595, bv: 0.573 },
    { mv: 4.349, bv: 0.531 },
    { mv: 3.89, bv: 0.457 },
    { mv: 3.481, bv: 0.393 },
    { mv: 3.292, bv: 0.362 },
    { mv: 2.94, bv: 0.297 },
    { mv: 2.776, bv: 0.263 },
    { mv: 2.513, bv: 0.207 },
    { mv: 2.342, bv: 0.167 },
    { mv: 2.218, bv: 0.138 },
    { mv: 2.007, bv: 0.093 },
    { mv: 1.997, bv: 0.091 },
    { mv: 1.803, bv: 0.055 },
    { mv: 1.793, bv: 0.053 },
    { mv: 1.628, bv: 0.026 },
  ],
  '0.400': [
    { mv: 13.467, bv: 1.748 },
    { mv: 12.117, bv: 1.633 },
    { mv: 11.646, bv: 1.597 },
    { mv: 11.414, bv: 1.58 },
    { mv: 11.063, bv: 1.553 },
    { mv: 10.527, bv: 1.518 },
    { mv: 10.517, bv: 1.517 },
    { mv: 9.759, bv: 1.465 },
    { mv: 9.369, bv: 1.438 },
    { mv: 8.076, bv: 1.221 },
    { mv: 7.48, bv: 1.123 },
    { mv: 6.922, bv: 1.014 },
    { mv: 6.089, bv: 0.866 },
    { mv: 5.736, bv: 0.799 },
    { mv: 5.115, bv: 0.672 },
    { mv: 4.835, bv: 0.618 },
    { mv: 4.321, bv: 0.528 },
    { mv: 4.083, bv: 0.489 },
    { mv: 3.644, bv: 0.422 },
    { mv: 3.442, bv: 0.391 },
    { mv: 3.067, bv: 0.33 },
    { mv: 2.891, bv: 0.296 },
    { mv: 2.722, bv: 0.263 },
    { mv: 2.535, bv: 0.227 },
    { mv: 2.414, bv: 0.202 },
    { mv: 2.275, bv: 0.174 },
    { mv: 2.222, bv: 0.163 },
    { mv: 2.052, bv: 0.129 },
    { mv: 2.022, bv: 0.124 },
    { mv: 1.814, bv: 0.088 },
    { mv: 1.791, bv: 0.085 },
    { mv: 1.682, bv: 0.068 },
  ],
  '0.600': [
    { mv: 13.498, bv: 1.75 },
    { mv: 12.118, bv: 1.631 },
    { mv: 12.004, bv: 1.624 },
    { mv: 11.069, bv: 1.555 },
    { mv: 10.533, bv: 1.52 },
    { mv: 9.372, bv: 1.44 },
    { mv: 8.761, bv: 1.303 },
    { mv: 7.481, bv: 1.127 },
    { mv: 7.453, bv: 1.122 },
    { mv: 6.916, bv: 1.014 },
    { mv: 6.472, bv: 0.938 },
    { mv: 5.721, bv: 0.797 },
    { mv: 5.097, bv: 0.67 },
    { mv: 4.815, bv: 0.616 },
    { mv: 4.548, bv: 0.568 },
    { mv: 4.295, bv: 0.526 },
    { mv: 3.825, bv: 0.453 },
    { mv: 3.704, bv: 0.435 },
    { mv: 3.403, bv: 0.39 },
    { mv: 3.208, bv: 0.36 },
    { mv: 2.841, bv: 0.296 },
    { mv: 2.669, bv: 0.264 },
    { mv: 2.614, bv: 0.255 },
    { mv: 2.433, bv: 0.224 },
    { mv: 2.352, bv: 0.21 },
    { mv: 2.205, bv: 0.186 },
    { mv: 2.14, bv: 0.174 },
    { mv: 1.957, bv: 0.145 },
    { mv: 1.931, bv: 0.14 },
    { mv: 1.801, bv: 0.121 },
    { mv: 1.7, bv: 0.107 },
    { mv: 1.633, bv: 0.098 },
  ],
  '1.000': [
    { mv: 13.5, bv: 1.75 },
    { mv: 11.972, bv: 1.624 },
    { mv: 11.629, bv: 1.598 },
    { mv: 11.074, bv: 1.558 },
    { mv: 10.538, bv: 1.521 },
    { mv: 9.855, bv: 1.474 },
    { mv: 9.284, bv: 1.424 },
    { mv: 8.499, bv: 1.264 },
    { mv: 8.079, bv: 1.225 },
    { mv: 7.428, bv: 1.119 },
    { mv: 6.873, bv: 1.009 },
    { mv: 6.432, bv: 0.934 },
    { mv: 6.055, bv: 0.864 },
    { mv: 5.635, bv: 0.782 },
    { mv: 5.063, bv: 0.666 },
    { mv: 4.776, bv: 0.612 },
    { mv: 4.383, bv: 0.545 },
    { mv: 3.995, bv: 0.484 },
    { mv: 3.536, bv: 0.419 },
    { mv: 3.324, bv: 0.39 },
    { mv: 3.122, bv: 0.362 },
    { mv: 2.927, bv: 0.334 },
    { mv: 2.74, bv: 0.306 },
    { mv: 2.563, bv: 0.28 },
    { mv: 2.404, bv: 0.261 },
    { mv: 2.286, bv: 0.247 },
    { mv: 2.165, bv: 0.236 },
    { mv: 1.947, bv: 0.218 },
    { mv: 1.898, bv: 0.214 },
    { mv: 1.737, bv: 0.205 },
    { mv: 1.648, bv: 0.203 },
    { mv: 1.543, bv: 0.201 },
  ],
};

const META: Record<string, { label: string; note: string }> = {
  '0.080': { label: '80 Myr', note: 'PARSEC turnoff higher than M34 fit' },
  '0.100': { label: '100 Myr', note: 'Pleiades-age PARSEC track' },
  '0.200': { label: '200 Myr', note: 'M34 reference age — compare to YY gold track' },
  '0.400': { label: '400 Myr', note: 'Hyades-age PARSEC track' },
  '0.600': { label: '600 Myr', note: 'Mature open cluster' },
  '1.000': { label: '1 Gyr', note: 'Old open cluster' },
};

export const PARSEC_ISOCHRONE_AGES: AgeIsochrone[] = Object.entries(RAW)
  .map(([k, points]) => ({
    ageGyr: parseFloat(k),
    label: `PARSEC ${META[k].label}`,
    shortLabel: `P ${META[k].label}`,
    note: META[k].note,
    points,
  }))
  .sort((a, b) => a.ageGyr - b.ageGyr);

export const PARSEC_M34 = PARSEC_ISOCHRONE_AGES.find((a) => a.ageGyr === 0.2)!;

export const PARSEC_COMPARE_AGES = PARSEC_ISOCHRONE_AGES.filter((a) =>
  [0.1, 0.2, 0.4, 0.6].includes(a.ageGyr),
);
